import { render, staticRenderFns } from "./RfqsSimpleList.vue?vue&type=template&id=1573e3f4&scoped=true"
import script from "./RfqsSimpleList.vue?vue&type=script&lang=js"
export * from "./RfqsSimpleList.vue?vue&type=script&lang=js"
import style0 from "./RfqsSimpleList.vue?vue&type=style&index=0&id=1573e3f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573e3f4",
  null
  
)

export default component.exports